module.exports = __webpack_public_path__ + "static/ZEP_Prozess_Anwendung-3a9ccbc6d14500bbc9c8cebd68a5cfd8.pdf";